import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

const mapStateToProps = (state) => ({
  featureFlags: state.getIn(['app', 'featureFlags'])
});

class FeatureFlagContainer extends React.Component {
  render () {
    return this.props.children(this.props.featureFlags);
  }
}

FeatureFlagContainer.propTypes = {
  children: PropTypes.func.isRequired,
  featureFlags: ImmutablePropTypes.mapOf(PropTypes.bool, PropTypes.string)
};

export default connect(mapStateToProps)(FeatureFlagContainer);



// WEBPACK FOOTER //
// ./app/containers/FeatureFlagContainer.jsx